import React, { useEffect } from "react";
import {
  Button,
  Link,
  Flex,
  Text,
  Avatar,
  Menu,
  MenuButton,
  MenuList,
  MenuItem,
  Image,
} from "@chakra-ui/react";
import { Link as RouterLink } from "react-router-dom";
import { useUser } from "../../contexts/UserContext";
import { useNavigate } from "react-router-dom";
import { supabase } from "../../lib/supabaseClient";

const Header = () => {
  const { userInfo, isLoading } = useUser();
  const navigate = useNavigate();

  useEffect(() => {
    // 로딩 중이 아니고, userInfo가 있고, Admin 권한이 없을 때만 리다이렉트
    if (!isLoading && userInfo && !userInfo.role?.includes("Admin")) {
      navigate("/");
    }
  }, [userInfo, isLoading, navigate]);

  const handleLogout = async () => {
    await supabase.auth.signOut();
    navigate("/login");
  };

  return (
    <Flex
      as="header"
      align="center"
      justify="space-between"
      w="100%"
      px={4}
      py={2}
      bg="white"
      borderBottom="1px solid #e2e8f0"
      h="60px"
      position="fixed"
      top="0"
      left="0"
      zIndex="1000"
    >
      <Link as={RouterLink} to="/" _hover={{ textDecoration: "none" }}>
        <Image src="/laeebly-icon.png" alt="Laeebly Logo" h="40px" />
      </Link>
      <Flex align="center">
        <Menu>
          <MenuButton>
            <Flex align="center">
              <Avatar
                size="sm"
                name={userInfo?.name}
                src={userInfo?.img_profile}
                mr={2}
              />
              <Text fontWeight="bold">{userInfo?.name || "Admin"}</Text>
            </Flex>
          </MenuButton>
          <MenuList>
            <MenuItem onClick={handleLogout}>로그아웃</MenuItem>
          </MenuList>
        </Menu>
      </Flex>
    </Flex>
  );
};

export default Header;
